export default "__VITE_ASSET__CUqfZPPt__"